var render = function render(){var _vm=this,_c=_vm._self._c;return _c('s-page',[_vm._v(" Select a page from the menu above to continue. ")])
}
var staticRenderFns = []

export { render, staticRenderFns }